<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <base-material-card
          color="primary"
          icon="mdi-account-lock-outline"
          inline
          class="px-5 py-3"
          :title="`Permissões de Edição :: ${versaoTitulo}`"
        >
          <!-- Info Alert -->
          <v-alert dense outlined type="info" color="primary" class="mb-5 mt-4">
            Por padrão, todo administrador pode editar os dados desta versão da BDGD. Mova um usuário para
            <strong>Bloqueados</strong>
            para impedir que ele edite dados desta versão.
          </v-alert>

          <base-dual-list-transfer
            v-model="usuariosBloqueadosIds"
            :items="usuariosAdmin"
            :loading="loading"
            left-title="Bloqueados"
            left-icon="mdi-account-lock"
            right-title="Podem editar"
            right-icon="mdi-account-check"
            search-label="Pesquisar usuário"
            select-all-label="Bloquear todos"
            clear-label="Limpar bloqueados"
            item-value="id"
            item-text="nome"
          />
        </base-material-card>
      </v-col>
    </v-row>

    <!-- Save button -->
    <v-row>
      <v-col cols="12" class="d-flex justify-end">
        <v-btn color="primary" min-width="120" :loading="loading" @click="save()">Salvar</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { formatToMonth } from '@/filters';
  import BdgdVersionsService from '@/services/BdgdVersionsService.js';
  import PermissoesEdicaoBdgdService from '@/services/PermissoesEdicaoBdgdService';
  import UsuariosService from '@/services/UsuariosService';

  export default {
    name: 'VersoesBdgdsPermissoesEdicao',

    data: () => ({
      versao: null,
      usuariosAdmin: [],
      usuariosBloqueadosIds: [],
      loading: false
    }),

    computed: {
      versaoTitulo() {
        if (!this.versao) return '';
        return `BDGD ${formatToMonth(this.versao.data_registro)} v${this.versao.versao}`;
      }
    },

    mounted() {
      this.getVersao();
      this.getUsuariosAdmin();
      this.getUsuariosBloqueados();
    },

    methods: {
      getVersao() {
        BdgdVersionsService.getById(this.$route.params.id)
          .then((versao) => (this.versao = versao))
          .catch(() => this.$toast.error('Erro ao buscar os dados da versão da BDGD.', '', { position: 'topRight' }));
      },

      getUsuariosAdmin() {
        this.loading = true;
        UsuariosService.getUsuarios()
          .then((response) => {
            this.usuariosAdmin = response.data.data.filter((usuario) => usuario.admin && usuario.ativo === 'Ativo');
          })
          .catch(() => this.$toast.error('Erro ao buscar os usuários administradores.', '', { position: 'topRight' }))
          .finally(() => (this.loading = false));
      },

      getUsuariosBloqueados() {
        PermissoesEdicaoBdgdService.listarUsuariosBloqueados(this.$route.params.id)
          .then((response) => (this.usuariosBloqueadosIds = response.data))
          .catch(() =>
            this.$toast.error('Erro ao buscar os usuários bloqueados para edição desta versão.', '', {
              position: 'topRight'
            })
          );
      },

      save() {
        this.loading = true;

        PermissoesEdicaoBdgdService.sincronizarUsuariosBloqueados(this.$route.params.id, this.usuariosBloqueadosIds)
          .then(() => this.$toast.success('Permissões de edição salvas com sucesso.', '', { position: 'topRight' }))
          .catch(() =>
            this.$toast.error('Erro ao salvar as permissões de edição desta versão da BDGD.', '', {
              position: 'topRight'
            })
          )
          .finally(() => (this.loading = false));
      }
    }
  };
</script>
